import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';

const moduleSelector = '.testimonials__slider';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      const slider = document.createElement('div');
      slider.classList.add('splide');
      const track = document.createElement('div');
      track.classList.add('splide__track');
      const list = document.createElement('div');
      list.classList.add('splide__list');
      track.appendChild(list);
      slider.appendChild(track);
      query.appendChild(slider);

      data.forEach((item) => {
        const slide = document.createElement('div');
        slide.classList.add('splide__slide');
        list.appendChild(slide);

        slide.innerHTML = /* html */ `
          <div class="testimonial">
            <div class="testimonial__rating">
              ${Array.from({ length: item.rating }, () => `<span class="testimonial__rating-icon"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.09373 1.60005C9.1777 1.43153 9.30698 1.28975 9.46707 1.19066C9.62716 1.09156 9.81171 1.03906 9.99998 1.03906C10.1883 1.03906 10.3728 1.09156 10.5329 1.19066C10.693 1.28975 10.8223 1.43153 10.9062 1.60005L13.2562 6.36255L18.5062 7.12505C18.6929 7.15229 18.8682 7.23113 19.0125 7.35269C19.1567 7.47425 19.2642 7.63369 19.3226 7.81304C19.3811 7.99238 19.3883 8.1845 19.3435 8.36773C19.2986 8.55096 19.2035 8.71801 19.0687 8.85005L15.2687 12.5563L16.1687 17.7875C16.2009 17.9738 16.1804 18.1654 16.1093 18.3406C16.0383 18.5157 15.9196 18.6675 15.7668 18.7787C15.6139 18.89 15.433 18.9562 15.2445 18.9699C15.0559 18.9836 14.8673 18.9442 14.7 18.8563L9.99998 16.3563L5.29998 18.8563C5.13266 18.9442 4.94405 18.9836 4.75552 18.9699C4.56698 18.9562 4.38605 18.89 4.2332 18.7787C4.08035 18.6675 3.96169 18.5157 3.89065 18.3406C3.81961 18.1654 3.79903 17.9738 3.83123 17.7875L4.73123 12.5563L0.931235 8.85005C0.796511 8.71801 0.701354 8.55096 0.656491 8.36773C0.611629 8.1845 0.618845 7.99238 0.677328 7.81304C0.73581 7.63369 0.843232 7.47425 0.987481 7.35269C1.13173 7.23113 1.30707 7.15229 1.49373 7.12505L6.74373 6.36255L9.09373 1.60005Z" fill="#FEC327"/>
</svg></span>`).join('')}
            </div>
            <p class="testimonial__text">${item.testimonial}</p>
            <span class="testimonial__name">${item.name}</span>
          </div>
        `;
      });

      const splide = new Splide(slider, {
        type: 'loop',
        perPage: 3,
        perMove: 1,
        arrows: true,
        pagination: false,
        gap: 30,
        padding: {
          left: 0,
          right: '10%',
        },
        breakpoints: {
          1200: {
            perPage: 2,
          },
          768: {
            perPage: 1,
            padding: {
              left: 0,
              right: 0,
            },
          },
        },
      });

      splide.mount();
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
